<br><br>

<div class="actuator-container">
  <h2>Build Versions</h2>

  <div class="grid">

    <div class="card">
      <h3>CRM API</h3>
      <p><strong>Build Number:</strong> {{ web?.crmapi?.build?.jenkinsBuildNumber }}</p>
    </div>

    <div class="card">
      <h3>PAYMENT API</h3>
      <p><strong>Build Number:</strong> {{ web?.paymentapi?.build?.jenkinsBuildNumber }}</p>
    </div>


    <div class="card">
      <h3>ISM API</h3>
      <p><strong>Build Number:</strong> {{ web?.ismapi?.build?.jenkinsBuildNumber }}</p>
    </div>

    <div class="card">
      <h3>WTS API</h3>
      <p><strong>Build Number:</strong> {{ web?.wtsapi?.build?.jenkinsBuildNumber }}</p>
    </div>

    <div class="card">
      <h3>Kafka API</h3>
      <p><strong>Build Number:</strong> {{ web?.kafkaapi?.build?.jenkinsBuildNumber }}</p>
    </div>

  </div>

</div>

<br> <br>


<div class="client-container">
  <h2>Web Client Versions</h2>

  <div class="grid">

    <div class="card">
      <h3>Web Client</h3>
      <p><strong>Build Number:</strong> {{ web?.webclient?.jenkinsBuildNumber }}</p>
    </div>

    <div class="card">
      <h3>Payment Client</h3>
      <p><strong>Build Number:</strong> {{ web?.paymentClient?.jenkinsBuildNumber }}</p>
    </div>
  </div>


</div>


<br> <br>


<div class="actuator-container">
  <h2>Webbox Versions</h2>

  <div class="grid">

    <div class="card">
      <h3>CRM API</h3>
      <p><strong>Build Number:</strong> {{ webbox?.crmapi?.build?.jenkinsBuildNumber }}</p>
    </div>

    <div class="card">
      <h3>PAYMENT API</h3>
      <p><strong>Build Number:</strong> {{ webbox?.paymentapi?.build?.jenkinsBuildNumber }}</p>
    </div>


    <div class="card">
      <h3>ISM API</h3>
      <p><strong>Build Number:</strong> {{ webbox?.ismapi?.build?.jenkinsBuildNumber }}</p>
    </div>

    <div class="card">
      <h3>WTS API</h3>
      <p><strong>Build Number:</strong> {{ webbox?.wtsapi?.build?.jenkinsBuildNumber }}</p>
    </div>

    <div class="card">
      <h3>Kafka API</h3>
      <p><strong>Build Number:</strong> {{ webbox?.kafkaapi?.build?.jenkinsBuildNumber }}</p>
    </div>

  </div>

</div>

<br><br>


<div class="client-container">
  <h2>Webbox Client Versions</h2>

  <div class="grid">

    <div class="card">
      <h3>CRM Client</h3>
      <p><strong>Build Number:</strong> {{ webbox?.crmclient?.jenkinsBuildNumber }}</p>
    </div>

    <div class="card">
      <h3>Admin Client</h3>
      <p><strong>Build Number:</strong> {{ webbox?.adminClient?.jenkinsBuildNumber }}</p>
    </div>


  </div>

</div>